<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">keyboard</v-icon>
          <span class="headline ml-2 white--text">Backoffice</span>
          <v-spacer/>
          <v-btn @click="add"
                 v-if="validRole"
                 depressed class="action white--text rounded-sm">Add
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
              v-if="backofficeItems"
              :items="backofficeItems"
              hide-default-footer
              :headers="tableHeaders"
              class="px-2 mt-0 pt-0 row-pointer"
              @click:row="showItem"
          >
            <template v-slot:item.updated_at="props">
              <td class="text-left">
                {{ props.item.updated_at ? props.item.updated_at : "" }}
              </td>
            </template>
            <template v-slot:footer>
              <div class="py-1 mt-6" v-if="tableHeaders">
                <div class="text-center">
                  <v-btn
                      fab
                      small
                      class="theme white--text"
                      depressed
                      @click="previous"
                      :disabled="pagination.page<=0"
                  >
                    <v-icon small>navigate_before</v-icon>
                  </v-btn>
                  <span class="px-6">{{ pagination.page + 1 }}</span>
                  <v-btn
                      fab
                      small
                      depressed
                      class="theme white--text"
                      @click="next"
                      :disabled="pagination.disableNext"
                  >
                    <v-icon small>navigate_next</v-icon>
                  </v-btn>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!--    <v-col cols="12" lg="3" class="pl-1">-->
    <!--      <v-card flat class="mt-14">-->
    <!--        <v-card-title>-->
    <!--          <span class="title font-weight-regular theme-text"-->
    <!--          >Manage backoffice items</span>-->
    <!--        </v-card-title>-->
    <!--        <v-card-text class="pt-0">-->
    <!--          <div class="grey&#45;&#45;text text&#45;&#45;darken-1 mt-1">-->
    <!--            This is your backoffice - a place to share common information, policies, documents-->
    <!--            with your employees.-->
    <!--          </div>-->
    <!--        </v-card-text>-->
    <!--      </v-card>-->
    <!--    </v-col>-->

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";
import {TableHeaders} from "@/views/headers";

export default {
  name: Component.Protected.Backoffice.List,
  computed: {
    ...mapGetters(["userInfo", "backofficeItems"])
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Backoffice.List,
    tableHeaders: TableHeaders.Backoffice.List,
    search: {
      limit: 10,
      offset: 0
    },
    pagination: {
      disableNext: true,
      page: 0
    }
  }),
  methods: {
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.backofficeItems.length <= this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.lisBackofficeItems();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.lisBackofficeItems();
      }
    },
    add() {
      this.$router.push({name: Component.Protected.Backoffice.Add});
    },
    setup() {
      this.tokenHeaders = {headers: {"id-token": this.userInfo.token}};
      this.lisBackofficeItems();
    },
    lisBackofficeItems() {
      this.$store.dispatch(Actions.Backoffice.Find, this.search).then(() => {
        let len = this.backofficeItems.length;
        if ((len < this.search.limit && len > 0) || len === 0) {
          this.pagination.disableNext = true;
        } else if (len === this.search.limit) {
          this.pagination.disableNext = false;
        }
      }).catch(e => {
        console.error(Constants.BackOffice.Messages.Error.Find, e);
        this.snackbarMessage = Constants.BackOffice.Messages.Error.Find;
        this.snackbar = true;
      });
    },
    showItem(item) {
      if (!item.id) return false;
      if (this.userInfo.role === Constants.Roles.HR || this.userInfo.role === Constants.Roles.Manager) {
        this.$router.push({name: Component.Protected.Backoffice.Edit, params: {id: item.id}});
      } else {
        this.$router.push({name: Component.Protected.Backoffice.Read, params: {id: item.id}});
      }
    },
    validRole() {
      return this.userInfo.role === Constants.Roles.Manager ||
          this.userInfo.role === Constants.Roles.HR;
    }
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  }
};
</script>